define("shared/utils/plans-data/feature-mappings", ["exports", "shared/utils/plans-data/feature-keys"], function (_exports, _featureKeys) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/plans-data/feature-keys"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class featureMappingsUtil
   * @extends Utils
   */
  /**
   * Maps features on features object
   *
   * @method featureMappings
   * @param {Service} intl
   *
   * @returns {Record<string, (plan: SubscriptionPlanModel) => unknown} Features with specific copy
   */
  const featureMappings = (intl, plan) => ({
    canvaExport: () => Boolean(plan.isPaid),
    campaignBoard: () => Boolean(plan.isPaid),
    createMediaKit: () => {
      // all plans including free
      return true;
    },
    exportAnalytics: _ref => {
      let {
        analyticsExport
      } = _ref;
      return analyticsExport ? intl.t('plans.analytics_export_csv') : true;
    },
    groups: _ref2 => {
      let {
        accessGroups
      } = _ref2;
      return accessGroups ? intl.t('plans.feature_mappings.unlimited') : intl.t('plans.feature_mappings.one');
    },
    ideas: () => Boolean(plan.isPaid),
    igAnalytics: _ref3 => {
      let {
        analyticsExport
      } = _ref3;
      const MONTHS_PER_YEAR = 12;
      if (plan.numberOfAnalyticsMonths > 0) {
        return plan.numberOfAnalyticsMonths % MONTHS_PER_YEAR === 0 ? intl.t('plans.analytics_time_range', {
          unit: 'year',
          count: plan.numberOfAnalyticsMonths / MONTHS_PER_YEAR
        }) : intl.t('plans.analytics_time_range', {
          unit: 'month',
          count: plan.numberOfAnalyticsMonths
        });
      }
      return analyticsExport ? intl.t('plans.analytics_export_csv') : true;
    },
    igPostPerformance: _ref4 => {
      let {
        analyticsExport
      } = _ref4;
      return analyticsExport ? intl.t('plans.full_posts') : intl.t('plans.limited_posts');
    },
    igStoryPerformance: _ref5 => {
      let {
        analyticsExport
      } = _ref5;
      return analyticsExport ? intl.t('plans.full_posts') : false;
    },
    igReelsScheduling: () => plan.isPaid,
    linkinbio: _ref6 => {
      let {
        linkinbioButtonColor,
        linkinbioBannerless
      } = _ref6;
      let featureAccess = true;
      if (plan.planType === 'enterprise') {
        featureAccess = intl.t('plans.linkin_bio.page_amount', {
          count: intl.t('shared_words.multiple')
        });
      } else if (linkinbioBannerless) {
        featureAccess = intl.t('plans.linkin_bio.page_amount', {
          count: plan.numberOfSocialSets
        });
      } else if (linkinbioButtonColor) {
        featureAccess = intl.t('plans.linkin_bio.page_amount', {
          count: 1
        });
      }
      return featureAccess;
    },
    linkinbioBannerless: _ref7 => {
      let {
        linkinbioBannerless
      } = _ref7;
      return linkinbioBannerless;
    },
    linkinbioAnalytics: _ref8 => {
      let {
        linkinbioExtendedClickAnalytics
      } = _ref8;
      return linkinbioExtendedClickAnalytics ? `${intl.t('plans.full_posts')}<br>${intl.t('plans.linkin_bio.page_views')}` : intl.t('plans.limited_months');
    },
    linkinbioButton: () => {
      //Note: non-legacy accounts, including free.
      return true;
    },
    linkinbioGoogleAnalytics: () => Boolean(plan.isPaid),
    linkinbioFeaturedBanner: () => {
      return plan.numberOfLinkinbioFeaturedBanners > 0;
    },
    linkinbioFeaturedMedia: _ref9 => {
      let {
        linkinbioFeaturedMediaImage,
        linkinbioFeaturedMediaVideo
      } = _ref9;
      return linkinbioFeaturedMediaImage && linkinbioFeaturedMediaVideo && plan.numberOfLinkinbioFeaturedMediaCustomMedia > 0;
    },
    mediaEditing: _ref10 => {
      let {
        videoCoverSelect,
        textOnImages
      } = _ref10;
      return videoCoverSelect && textOnImages;
    },
    prioritySupport: () => {
      const prioritySupportPlans = ['scale202506'];
      return prioritySupportPlans.includes(plan.planType);
    },
    shareMediaKit: () => {
      // all plans including free
      return true;
    },
    tiktokAnalyticsTime: _ref11 => {
      let {
        tiktokAnalytics
      } = _ref11;
      if (!tiktokAnalytics) {
        return false;
      }
      const MONTHS_PER_YEAR = 12;
      if (plan.numberOfAnalyticsMonths > 0) {
        return plan.numberOfAnalyticsMonths % MONTHS_PER_YEAR === 0 ? intl.t('plans.analytics_time_range', {
          unit: 'year',
          count: plan.numberOfAnalyticsMonths / MONTHS_PER_YEAR
        }) : intl.t('plans.analytics_time_range', {
          unit: 'month',
          count: plan.numberOfAnalyticsMonths
        });
      }
      return intl.t('plans.limited_months');
    },
    twitterPinterestAnalytics: features => {
      let featureAccess = false;
      if (features.twAnalytics && features.pinAnalytics) {
        featureAccess = intl.t('plans.limited_months');
      } else if (features.twitterClickTracking && features.pinterestClickTracking) {
        featureAccess = intl.t('plans.click_tracking');
      }
      return featureAccess;
    },
    youtubeShorts: () => Boolean(plan.isPaid)
  });

  /**
   * Maps plan feature details
   *
   * @method planFeatures
   * @param {Service} intl
   *
   * @returns {Record<string, (plan: SubscriptionPlanModel) => PlanFeatures} plan features with specific copy
   */

  const planFeatures = intl => ({
    aiCaptionWriter: plan => {
      return {
        aiCaptionWriter: Boolean(plan.numberOfAiCredits)
      };
    },
    autoPublish: plan => {
      return {
        autoPublish: plan.isPaid
      };
    },
    numberOfPosts: plan => ({
      posts: plan.numberOfPosts === -1 ? intl.t('plans.feature_mappings.unlimited') : `${plan.numberOfPosts}`,
      postsNumber: plan.numberOfPosts
    }),
    numberOfSocialSets: plan => {
      let extraSocialSets = 0;
      let extraSocialSetsYearly = 0;
      if (plan.canAddSocialSets) {
        extraSocialSets = Math.round(plan.additionalSocialSetCosts.monthly.dollars * 100) / 100;
        extraSocialSetsYearly = Math.round(plan.additionalSocialSetCosts.yearly.cents * 100 / 100);
      }
      return {
        socialSets: plan.numberOfSocialSets,
        extraSocialSets,
        extraSocialSetsYearly
      };
    },
    numberOfUsers: plan => {
      let extraUsers = 0;
      let extraUsersYearly = 0;
      if (plan.canAddUsers) {
        extraUsers = Math.round(plan.additionalUserCosts.monthly.dollars * 100) / 100;
        extraUsersYearly = Math.round(plan.additionalUserCosts.yearly.cents * 100 / 100);
      }
      return {
        users: plan.numberOfUsers,
        extraUsers,
        extraUsersYearly
      };
    },
    numberOfAiCredits: plan => {
      let extraAiCredits = 0;
      let extraAiCreditsYearly = 0;
      if (plan.canAddAiCredits) {
        // Note: Not dividing by 100 here as the addon price is the price per credit and we sell credits in bundles of 100
        extraAiCredits = plan.additionalAiCreditCosts.monthly.dollars * 100;
        extraAiCreditsYearly = Math.round(plan.additionalAiCreditCosts.yearly.cents * 100);
      }
      return {
        aiCredits: plan.numberOfAiCredits ?? 0,
        extraAiCredits,
        extraAiCreditsYearly
      };
    },
    tags: plan => {
      let featureAccess = false;
      if (plan.numberOfCollectTags === -1) {
        featureAccess = intl.t('plans.add_unlimited_media');
      }
      if (plan.hasLimitedCollectTags) {
        featureAccess = intl.t('plans.collect_tags', {
          count: plan.numberOfCollectTags
        });
      }
      return {
        tags: featureAccess
      };
    },
    features: plan => {
      const features = {};
      for (const [key, value] of Object.entries(_featureKeys.default)) {
        Object.assign(features, {
          [key]: plan.features[value]
        });
      }
      const featuresMappings = featureMappings(intl, plan);
      return {
        ...features,
        ...Object.assign(...Object.keys(featuresMappings).map(key => ({
          [key]: featuresMappings[key](features)
        })))
      };
    }
  });
  var _default = _exports.default = planFeatures;
});